
import React, { useEffect } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { FormGroup, Icon, Select, useForm, Yup } from '../components';
import {  useCreateDmpMutation, usePushDmpMutation, useGetDmpAdaptersQuery } from '../../api/dmpApiSlice';

const DmpModal = ({ show, onClose }) => {
  const { t } = useTranslation();
  const initialValues = {
    name: "",
    adapter_class: ""
  }
  const validationSchema = Yup.object().shape({
    name: Yup.string(),
    adapter_class: Yup.string()
  })
  const [createDmp] = useCreateDmpMutation();
  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (data) => {
      createDmp({ dmp: { ...data } }).unwrap().then(onClose)
    },
  });
  const { data: adapters } = useGetDmpAdaptersQuery();
  const { adapters: adaptersArray } = adapters || {};
  const adapterOptions = adaptersArray?.map(adapter => ({ label: adapter.name, value: adapter.value })) || [];

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {t("new")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form {...formProps}>
          <Form.Row>
            <FormGroup input="text" as={Col} md={12} lg={12} {...getInputProps("name")} label={t('dmp.form.name')} />
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col} md={12} lg={12} {...getInputProps("adapter_class")} label={t('dmp.form.adapter')}>
              <Select
                options= {adapterOptions}
              />
            </FormGroup>
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button key="submit" type="submit" variant="primary" {...submitButtonProps} >
          <Icon icon='save' text={t("save")} />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DmpModal;
